import { render, staticRenderFns } from "./BlacklistResultModal.vue?vue&type=template&id=28d75af3"
import script from "./BlacklistResultModal.vue?vue&type=script&lang=js"
export * from "./BlacklistResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports